/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FeatureImages } from '../../models/feature-images';

export interface GetFeatureImages$Params {
  year?: string;
  version?: string;
  featureFolderName?: string;
}

export function getFeatureImages(http: HttpClient, rootUrl: string, params?: GetFeatureImages$Params, context?: HttpContext): Observable<StrictHttpResponse<FeatureImages>> {
  const rb = new RequestBuilder(rootUrl, getFeatureImages.PATH, 'get');
  if (params) {
    rb.query('year', params.year, {});
    rb.query('version', params.version, {});
    rb.query('featureFolderName', params.featureFolderName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FeatureImages>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getFeatureImages.PATH = '/api/featuredetails/getfeatureimages';
getFeatureImages.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getFeatureImages.ROOTURL = '/portal';
